/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Freeze_Error_Already_UsedInputs */

const fr_membership_freeze_error_already_used = /** @type {(inputs: Membership_Freeze_Error_Already_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez déjà utilisé votre pause sur cette année de contrat.`)
};

/**

* @param {Membership_Freeze_Error_Already_UsedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_error_already_used = /** @type {((inputs?: Membership_Freeze_Error_Already_UsedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_Error_Already_UsedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_error_already_used(inputs)
});